import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { C } from "@/theme";
import { Field, FormScreen } from "@/ui";

export default function BookTest() {
  const [params] = useSearchParams();
  const riderId = params.get("riderId");
  const isRecert = params.get("mode") === "recert";
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [form, setForm] = useState({ date: "", location: "", examiner: "", notes: "" });
  const riderQ = useQuery({ queryKey: ["rider", riderId], queryFn: () => api.get(`/riders/${riderId}`), enabled: !!riderId });
  useEffect(() => { const b = riderQ.data?.test_booking; if (b) setForm({ date: (b.date ?? "").slice(0, 10), location: b.location ?? "", examiner: b.examiner ?? "", notes: b.notes ?? "" }); }, [riderQ.data]);
  const save = useMutation({
    mutationFn: () => api.post(`/riders/${riderId}/book-test`, { date: form.date, location: form.location, examiner: form.examiner, notes: form.notes, kind: isRecert ? "Recert Test" : "Official Test" }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["riders"] }); qc.invalidateQueries({ queryKey: ["rider", riderId] }); qc.invalidateQueries({ queryKey: ["dashboard"] }); navigate(-1); },
  });
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <FormScreen title={isRecert ? "Book Recert Test" : "Book Official Test"} onClose={() => navigate(-1)} onSave={() => save.mutate()} saving={save.isPending} saveDisabled={!form.date}>
      <p style={{ color: C.muted }} className="text-sm">{isRecert ? `Scheduling a recertification test for ${riderQ.data?.name ?? "this rider"}.` : riderQ.data?.name ? `Scheduling the official test for ${riderQ.data.name}.` : "Schedule the official test."}</p>
      <Field label="Test Date" value={form.date} onChange={set("date")} type="date" testID="booktest-date" />
      <Field label="Location" value={form.location} onChange={set("location")} placeholder="Test centre / meeting point" testID="booktest-location" />
      <Field label="Examiner Name" value={form.examiner} onChange={set("examiner")} placeholder="e.g. J. Smith" testID="booktest-examiner" />
      <Field label="Notes" value={form.notes} onChange={set("notes")} multiline placeholder="Any details for the rider" testID="booktest-notes" />
    </FormScreen>
  );
}
